var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.161 5.147h5.848c3.14 0 4.322 1.59 4.14 3.928-.302 3.856-2.633 5.987-5.725 5.987h-1.56c-.425 0-.71.28-.825 1.042l-.67 4.42c-.043.287-.194.455-.42.476H6.28c-.345 0-.468-.264-.377-.836L8.143 5.986c.09-.569.4-.839 1.018-.839z",
    fill: "#00A2D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.395 0h5.854c1.65 0 3.604.054 4.913 1.207.873.77 1.332 1.999 1.226 3.317-.359 4.47-3.033 6.974-6.618 6.974H7.883c-.492 0-.817.325-.956 1.207l-.806 5.125c-.052.333-.196.529-.459.552H2.056c-.4 0-.542-.306-.438-.969L4.215.973C4.319.313 4.679 0 5.395 0z",
    fill: "#1B3D92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.731 12.456l1.022-6.47c.09-.569.4-.839 1.019-.839h5.848c.968 0 1.75.151 2.363.43-.588 3.978-3.161 6.188-6.53 6.188H7.565c-.38 0-.663.194-.834.691z",
    fill: "#1B2E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.2fc7f9b1ac81076c195ffb706b968d8f.svg";
export { ForwardRef as ReactComponent };